module.exports = __webpack_public_path__ + "img/instagram.32f5b32c.svg";